import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import { Button } from "../components/ui/button";
import { AuthShell, AuthHeading, AuthField, AuthAlert } from "../components/AuthShell";
import { api, formatApiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(token ? "" : "This reset link is missing its token. Request a new one.");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      setDone(data.message);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      {done ? (
        <div className="space-y-6" data-testid="reset-success">
          <KeyRound className="h-10 w-10 text-emerald-400" />
          <AuthHeading title="Password updated" subtitle={done} />
          <Button asChild className="h-11 w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="reset-go-login">
            <Link to="/login">Sign in</Link>
          </Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-8" data-testid="reset-form">
          <AuthHeading title="New password" subtitle="Choose a new password for your account." />
          <div className="space-y-4">
            <AuthField id="password" label="New password (min 8 characters)" type="password" autoComplete="new-password" minLength={8} value={password} onChange={setPassword} testid="reset-password-input" />
            <AuthField id="confirm" label="Confirm new password" type="password" autoComplete="new-password" minLength={8} value={confirm} onChange={setConfirm} testid="reset-confirm-input" />
            {error && <AuthAlert testid="reset-error">{error}</AuthAlert>}
          </div>
          <Button type="submit" disabled={busy || !token} className="h-11 w-full bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold" data-testid="reset-submit-button">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Update password
          </Button>
          <p className="text-sm text-slate-400">
            <Link to="/forgot-password" className="text-amber-400 hover:underline" data-testid="reset-request-new-link">Request a new link</Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
